import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { WITHDRAW } from '../../actions/authActions'
import { FETCH_PROJECT } from '../../actions/editorActions'
import Button from '../../components/atoms/Button/Button'
import ImageAsset, { ImageAssetType } from '../../components/atoms/ImageAsset/ImageAsset'
import Logo, { LogoType } from '../../components/atoms/Logo/Logo'
import CommonFooter from '../../components/organisms/CommonFooter/CommonFooter'
import { CustomPcStore } from '../../store'
import * as styles from './WithdrawPage.css'

interface WithdrawPageProps {
  isWithdrawLoading: boolean
  isWithdrawed: boolean
  fetchProject: () => void
  withdrawError: string
  doWithdraw: () => void
}

class WithdrawPage extends React.PureComponent<WithdrawPageProps> {
  public componentDidMount() {
    this.props.fetchProject()
  }

  public render() {
    const { isWithdrawLoading, isWithdrawed, withdrawError, doWithdraw } = this.props

    const handleWithdraw = () => {
      if (
        window.confirm(
          'ご登録のアカウント・作成されたクイズ・参加者のランキングのすべてが削除されます。退会をご希望の方は「OK」を押してください。'
        )
      ) {
        // 退会処理
        doWithdraw()
      } // キャンセルが押された場合は何もしない
    }

    return (
      <div className={styles.background}>
        <div className={styles.container}>
          <div className={styles.backgroudImage}>
            <ImageAsset type={ImageAssetType.TOP_VISUAL} />
          </div>
          <div className={styles.mainContent}>
            <div className={styles.titlePart}>
              <div className={styles.logo}>
                <Logo type={LogoType.GRAY} />
              </div>
              {!isWithdrawLoading && isWithdrawed ? (
                <>
                  <p className={styles.text}>退会処理が完了いたしました</p>
                  <p className={styles.text}>Ennoshitaをご利用いただきありがとうございました</p>
                </>
              ) : (
                <>
                  <h1 className={styles.title}>Ennoshitaの退会</h1>
                  <p className={styles.text}>Ennoshitaをご利用いただきありがとうございました</p>
                  <p className={styles.text}>退会にあたっての注意事項をご確認ください</p>
                  <ul className={styles.warning}>
                    <li>ご登録のアカウント・作成されたクイズ・参加者のランキングのすべてが削除されます</li>
                    <li>削除された情報は退会後復旧することができません</li>
                  </ul>
                  <p className={styles.text}>
                    退会をご希望のお客様は以上の注意事項にご理解いただいた上で
                    <br />
                    下記ボタンよりご退会ください
                  </p>
                </>
              )}
            </div>
            {!isWithdrawLoading && isWithdrawed ? null : (
              <div className={styles.button}>
                <Button handleClick={() => handleWithdraw()} isLoading={isWithdrawLoading}>
                  退会する
                </Button>
              </div>
            )}
            {withdrawError ? <p className={styles.errorMessage}>{withdrawError}</p> : null}
          </div>
        </div>
        <CommonFooter />
      </div>
    )
  }
}

const mapStateToProps = (state: CustomPcStore) => ({
  isWithdrawLoading: state.auth.isWithdrawLoading,
  isWithdrawed: state.auth.isWithdrawed,
  withdrawError: state.auth.withdrawError
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchProject: () => dispatch(FETCH_PROJECT()),
  doWithdraw: () => dispatch(WITHDRAW())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithdrawPage)
